import React, {useEffect, useState} from 'react'
import i18n from 'i18next'
import Loading from '#components/a/Loading'
import {useWissensportalData} from '#hooks/useWissensportalData'
import AzubiWithCourses from '#components/m/Wissensportal/AzubiWithCourses'
import {DESIRED_MAX_COURSES_COUNT, ITEMS_PER_PAGE} from './WissensportalConstants'
import {filterAzubiList} from './WissensportalHelper'
import Text from '#components/a/Text'
import Pagination from '#components/m/Pagination'
import {useSelector} from 'react-redux'
import {useAzubisWithWissensportal} from '#hooks/useAzubisWithWissensportal'
import WissensportalAusbilderTrainerHeaderWithFilter from '#components/o/Wissensportal/WissensportalAusbilderTrainerHeaderWithFilter'
import PropTypes from 'prop-types'

function WissensportalAusbilderTrainerOverview({setFilters, selectedFilters}) {
  const selectedAzubiIdsFromGlobalFilter = useSelector(state => state.filter.matchingAzubiIds)
  const [globallyFilteredAzubisWithWissensportal, setGloballyFilteredAzubisWithWissensportal] = useState([])

  const [visibleAzubiIds, setVisibleAzubiIds] = useState()

  const [isLoading, setIsLoading] = useState(true)
  const [azubisWithWissensportal, setAzubisWithWissensportal] = useState()
  const [allAzubisWithCourses, setAllAzubisWithCourses] = useState([])
  const [uniqueCourses, setUniqueCourses] = useState([])
  const [uniqueModules, setUniqueModules] = useState([])

  const loadAzubisWithWissensportal = async () => {
    setIsLoading(true)
    const azubisWithWissensportal = await useAzubisWithWissensportal()
    setAzubisWithWissensportal(azubisWithWissensportal)
  }

  useEffect(() => {
    loadAzubisWithWissensportal()
  }, [])

  const filterCallback = filters => {
    setFilters(filters)
  }

  const scroll = (skip, take) => {
    const azubis = globallyFilteredAzubisWithWissensportal.slice(skip, skip + take)
    const azubiIds = azubis.map(a => a.id)
    const lastVisibleAzubiIdsString = visibleAzubiIds ? visibleAzubiIds.join(',') : ''
    const currentVisibleAzubiIdsString = azubiIds.join(',')
    if (lastVisibleAzubiIdsString !== currentVisibleAzubiIdsString) {
      setVisibleAzubiIds(azubiIds)
      setIsLoading(true)
      setAllAzubisWithCourses([])
    }
  }

  const azubisWithWissensportalIdsString = azubisWithWissensportal
    ? azubisWithWissensportal.map(a => a.id).join(',')
    : ''
  useEffect(() => {
    if (azubisWithWissensportal) {
      setGloballyFilteredAzubisWithWissensportal(
        azubisWithWissensportal.filter(a => selectedAzubiIdsFromGlobalFilter.includes(a.id)),
      )
      scroll(0, ITEMS_PER_PAGE)
    }
  }, [azubisWithWissensportalIdsString, selectedAzubiIdsFromGlobalFilter])

  const concatUniqueElementsInArraysById = (oldArray, newArray) => {
    let concatArray = oldArray.concat(newArray)
    concatArray = [...new Map(concatArray.map(item => [item['id'], item])).values()]
    return concatArray
  }

  const visibleAzubiIdsString = visibleAzubiIds ? visibleAzubiIds.join(',') : ''
  const oldUniqueCourses = uniqueCourses ? uniqueCourses : []
  const oldUniqueModules = uniqueModules ? uniqueModules : []

  const loadWissensportalData = async () => {
    if (visibleAzubiIds && visibleAzubiIds.length > 0) {
      const {allAzubisWithCourses, uniqueCourses, uniqueModules} = await useWissensportalData(visibleAzubiIds)
      let concatUniqueCourses = concatUniqueElementsInArraysById(oldUniqueCourses, uniqueCourses)
      let concatUniqueModules = concatUniqueElementsInArraysById(oldUniqueModules, uniqueModules)

      setIsLoading(false)
      setAllAzubisWithCourses(allAzubisWithCourses)
      setUniqueCourses(concatUniqueCourses)
      setUniqueModules(concatUniqueModules)
    } else {
      setIsLoading(false)
      setAllAzubisWithCourses([])
      setUniqueCourses([])
      setUniqueModules([])
    }
  }

  useEffect(() => {
    loadWissensportalData()
  }, [visibleAzubiIdsString])

  const azubisWithFilteredCoursesOfCurrentPage = filterAzubiList(selectedFilters, allAzubisWithCourses)

  return (
    <div className="wissensportal">
      <WissensportalAusbilderTrainerHeaderWithFilter
        selectedFilters={selectedFilters}
        uniqueCourses={uniqueCourses}
        uniqueModules={uniqueModules}
        filterCallback={filterCallback}
      />
      <Pagination data={globallyFilteredAzubisWithWissensportal} scrollCallback={scroll} take={ITEMS_PER_PAGE} />
      {!azubisWithWissensportal || (isLoading && <Loading />)}
      {azubisWithWissensportal &&
        globallyFilteredAzubisWithWissensportal &&
        globallyFilteredAzubisWithWissensportal.length === 0 &&
        !isLoading && <Text text={i18n.t('no_azubi_with_this_module')} />}
      <div className="wissensportal__content-wrapper wissensportal-ausbilder">
        {azubisWithFilteredCoursesOfCurrentPage &&
          azubisWithFilteredCoursesOfCurrentPage.map(x => (
            <AzubiWithCourses
              key={x.user.id}
              user={x.user}
              courses={x.courses}
              filteredModules={x.filteredModules}
              courseLimit={DESIRED_MAX_COURSES_COUNT}
            />
          ))}
      </div>
    </div>
  )
}

WissensportalAusbilderTrainerOverview.propTypes = {
  setFilters: PropTypes.func,
  selectedFilters: PropTypes.object,
}

export default WissensportalAusbilderTrainerOverview
